<template>
  <div class="root">
    <div class="counter h5">
      {{  cntCharTextArea + '/500' }}
    </div>
    <div class="flex textarea-box textarea-wrapper center-xs">
      <textarea
        rows="4"
        class="textarea-custom"
        :placeholder="$t(placeholderText)"
        onfocus="this.placeholder = ''"
        ref="comment"
        @blur="changePlaceholder"
        v-model="orderComment"
        maxlength="500"
        data-hj-whitelist
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    partnerCode: {
      type: [String],
      required: true
    }
  },
  data () {
    return {
      orderComment: '',
      placeholderText: 'Specify additional information for picker. For example: "The door code is 111" or "If you run out of red tomatoes, take the yellow tomatoes"'
    }
  },
  watch: {
    orderComment: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    }
  },
  computed: {
    ...mapGetters({
      getComments: 'checkout/getComments'
    }),

    cntCharTextArea () {
      return this.orderComment.length
    }
  },
  mounted () {
    let comments = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/comment'));
    if (comments) {
      let comment = comments.find(c => c.partner === this.partnerCode)
      if (comment) {
        this.orderComment = comment.comment
      }
    }
  },
  methods: {
    changePlaceholder () {
      this.$refs.comment.placeholder = this.$t(this.placeholderText);
    },

    sendDataToCheckout () {
      this.$bus.$emit(
        'checkout-after-comment',
        this.orderComment,
        this.partnerCode
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  ::placeholder {
    color: #bdbdbd;
    font-family: "TTNorms Regular", serif;
  }
  .root {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
  }
  .counter {
    position: absolute;
    right: 16px;
    bottom: 1px;
    background: white;
    padding: 0 4px 2px;
    border-radius: 4px;
  }
  .textarea-custom {
    width: 100%;
    resize: none;
    border: 1px solid #cecdcd;
    border-radius: 10px;
    padding: 10px;
    scrollbar-width: thin;

    &:focus, &:focus-visible {
      outline: none;
      border: 1px solid rgba(17, 187, 46, 0.8);
    }
  }
</style>
<style lang="scss">
  .textarea-custom-for-gift {
    max-height: 52px;
    textarea {
      border: none;
      min-height: 55px;
      margin-top: 0;
    }
  }
</style>
